import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';

import { getPage } from './get_page';
import { TrackEventArgs } from '../analytics.types';
import { TPageType } from '../../../common/types/applicationContext';

export const pageTypes: Record<TPageType, 'offerCalculator' | 'subsidizedCalculator'> = {
  subsidizedCalculator: 'subsidizedCalculator',
  offerCalculator: 'offerCalculator',
};

export const trackEvent =
  (deviceType: TDeviceType, pageType: TPageType) =>
  ({ user, action, label, extra }: TrackEventArgs) => {
    ca('eventSite', {
      name: 'oldevent',
      category: pageTypes[pageType],
      action,
      label,
      user,
      page: getPage({
        deviceType,
        extra,
        pageType: pageTypes[pageType],
      }),
    });
  };
